import {Component, Input} from '@angular/core';

import {Employee, EmployeeStatus} from '../../employees/employees.model';


@Component({
  selector: 'gp-display-employee-id',
  templateUrl: './gp-employee-id.component.html',
  styleUrls: ['./gp-employee-id.component.scss']
})
export class GPEmployeeIdComponent {
  public activeEmployeeStatus: EmployeeStatus = EmployeeStatus.ACTIVE;
  public inactiveEmployeeStatus: EmployeeStatus = EmployeeStatus.INACTIVE;
  public futureEmployeeStatus: EmployeeStatus = EmployeeStatus.FUTURE;

  @Input() employee: Employee;

}
